export enum WebhookType {
    CreateOrder = 'CREATE_ORDER',
    UpdateOrder = 'UPDATE_ORDER',
    UpdateOrderStatus = 'UPDATE_ORDER_STATUS',
    CreateProduct = 'CREATE_PRODUCT',
    UpdateProduct = 'UPDATE_PRODUCT',
    CreateReceiving = 'CREATE_RECEIVING',
    UpdateReceiving = 'UPDATE_RECEIVING',
    UpdateReceivingStatus = 'UPDATE_RECEIVING_STATUS',
    CreateReturn = 'CREATE_RETURN',
    UpdateReturn = 'UPDATE_RETURN',
    UpdateReturnStatus = 'UPDATE_RETURN_STATUS',
    CreateStockMovementStockCorrection = 'CREATE_STOCK_MOVEMENT_STOCK_CORRECTION',
    CreateStockMovementOrder = 'CREATE_STOCK_MOVEMENT_ORDER',
    CreateStockMovementReturn = 'CREATE_STOCK_MOVEMENT_RETURN',
    CreateStockMovementReceiving = 'CREATE_STOCK_MOVEMENT_RECEIVING',
    CreateStockMovementCompletition = 'CREATE_STOCK_MOVEMENT_COMPLETITION',
    CreateStockMovementQualityHold = 'CREATE_STOCK_MOVEMENT_QUALITY_HOLD',
    CreateStockMovementQualityRelease = 'CREATE_STOCK_MOVEMENT_QUALITY_RELEASE',
}

export enum WebhookMethod {
    POST = 'POST',
    GET = 'GET',
}

export enum WebhookPayloadVersion {
    V2 = 'v2',
    V21 = 'v21',
}

/**
 * Per webhook settings. Every parameter enriches the webhook payload with additional data
 * and is only accepted for the webhook types listed in WEBHOOK_PARAMETERS.
 */
export interface WebhookParameters {
    withPackingLists?: boolean;
}

export type WebhookParameterName = keyof WebhookParameters;

export interface WebhookParameterDefinition {
    webhookTypes: WebhookType[];
    description: string;
}

/**
 * Single source of truth for webhook parameters - drives API validation, documentation
 * and payload enrichment. A new parameter is added here and nowhere else.
 */
export const WEBHOOK_PARAMETERS: Record<WebhookParameterName, WebhookParameterDefinition> = {
    withPackingLists: {
        webhookTypes: [WebhookType.UpdateOrder, WebhookType.UpdateOrderStatus],
        description: 'Send expedition packages (orderProducts[].packingLists) together with the order detail.',
    },
};

export const WEBHOOK_PARAMETER_NAMES = Object.keys(WEBHOOK_PARAMETERS) as WebhookParameterName[];

export const isWebhookParameterEnabled = (
    parameters: WebhookParameters | null,
    name: WebhookParameterName,
    webhookType: WebhookType
): boolean => parameters?.[name] === true && WEBHOOK_PARAMETERS[name].webhookTypes.includes(webhookType);

export interface WebhookInterface {
    ID: number;
    ESHOP_KEY: string;
    WEBHOOK_TYPE: WebhookType | string;
    URL: string;
    ACTIVE: 0 | 1 | number;
    REGISTERED_AT: Date | null;
    UNREGISTERED_AT: Date | null;
    DEACTIVATION_EMAIL_SENT_AT: Date | null;
    METHOD: WebhookMethod;
    SECRET: string | null;
    PARAMETERS: WebhookParameters | null;
    PAYLOAD_VERSION: WebhookPayloadVersion;
}
